// Titan corporate-action emails: the slot contributions of `dowgate.ops.titan-corporate-actions.email` (SEP-360, SEP-376, ADR-0027).
//
// The Titan emails tab of the Corporate Actions page reads the feature with
// `useFeature`, so it needs no route here.
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const TitanEmailUpdatesCard = lazy(() =>
    import('@/components/coac/CoacUpdateCards').then((m) => ({
        default: m.TitanEmailUpdatesCard,
    })),
);

export default defineWebFeature({
    id: 'dowgate.ops.titan-corporate-actions.email',
    slots: {
        // SEP-376. The dashboard alert of the bell of the Titan emails tab: the
        // Titan emails that the signed-in Operations user has not read. The
        // card reads its rows inside its component, so `count` is null.
        'ops.dashboard.cards': [
            {
                key: 'titan-email-updates',
                order: 31,
                span: 6,
                title: 'Titan email updates',
                summary: 'The Titan emails that you have not read.',
                rows: 5,
                count: () => null,
                emptyBehaviour: 'keep',
                Component: TitanEmailUpdatesCard,
            },
        ],
    },
});
